import { cn } from "@/lib/utils";
import { ComponentProps } from "react";

type ButtonProps = ComponentProps<"button"> & {
  color?: "primary" | "secondary" | "accent"; // optional so it can fall back
};

export default function Button({
  children,
  color = "primary",
  className,
  ...rest
}: ButtonProps) {
  return (
    <button
      {...rest}
      className={cn(
        "p flex h-11.5 cursor-pointer items-center justify-center rounded rounded-br-3xl px-8 py-2 font-semibold text-white disabled:opacity-50",
        color === "primary" && "bg-primary",
        color === "secondary" && "bg-secondary",
        color === "accent" && "bg-accent",
        className,
      )}
    >
      {children}
    </button>
  );
}
